/**
 * @ngdoc controllers
 * @memberof mercury.modules.time.payroll.adjustment
 * @name TimePayrollAdjustmentListCtrl
 * Cook brothers adjustments
 * We can still use Adjustment within the controller/route/factory but not once we are interrogating any data from Cyrus
 */
angular.module('mercury.modules.time.payroll.adjustment')
.controller('TimePayrollAdjustmentListCtrl', ["dialog", "$q", "$scope", "TimePayrollAdjustment", "TimeStaff", "TimeRoles", "title", function(dialog, $q, $scope, TimePayrollAdjustment, TimeStaff, TimeRoles, title) {
  title.set('Pay Rate Adjustments');

  /**
   * All avaliable payrate adjustment types.
   */
  $scope.adjustmentTypes = {
    0: 'Dollar amount above normal rate',
    1: 'Dollar amount below normal rate',
    2: 'Fixed dollar amount',
    3: 'Percentage of normal rate'
  };

  $scope.showDeleted = false;

  /**
   * Fetch all active payrate adjustments.
   */
  $scope.loading = $q.all({
    adjustments: TimePayrollAdjustment.getAll(),
    staff: TimeStaff.getAllActive(),
    roles: TimeRoles.getAllActive()
  });
  $scope.loading.then(function(result) {
    $scope.adjustments = result.adjustments;
    $scope.staff = result.staff;
    $scope.roles = result.roles;
  });

  /**
   * Create a new Adjustment
   */
  $scope.addAdjustment = function() {
    $scope.adjustment = null;

    dialog.open({
      templateUrl: 'modules/time/payroll/adjustment/edit.tpl.html',
      controller: 'TimePayrollAdjustmentEditCtrl',
      scope: $scope
    })
    .then(function(newAdjustment) {
      $scope.adjustments.push(newAdjustment);
    });
  };

  /**
   * Copy the adjustment at the specified index into the edit model and open the editor
   * dialog
   */
  $scope.editAdjustment = function(adjustment) {
    $scope.adjustment = angular.copy(adjustment);

    dialog.open({
      templateUrl: 'modules/time/payroll/adjustment/edit.tpl.html',
      controller: 'TimePayrollAdjustmentEditCtrl',
      scope: $scope
    })
    .then(function(updatedAdjustment) {
      angular.forEach($scope.adjustments, function(adjustment, index) {
        if (adjustment.id == updatedAdjustment.id) {
          $scope.adjustments.splice(index, 1, updatedAdjustment);
        }
      });
    });
  };

  /**
   * Delete the specified adjustment
   */
  $scope.deleteAdjustment = function(adjustment) {
    TimePayrollAdjustment.remove(adjustment)
    .then(function() {
      adjustment.datestampDeleted = moment().format();
    });
  };

  /**
   * restore the specified adjustment
   */
  $scope.undeleteAdjustment = function(adjustment) {
    TimePayrollAdjustment.restore(adjustment)
    .then(function() {
      adjustment.datestampDeleted = null;
    });
  };
}]);
